import * as members from '../../privates/privateMembers';
import animationValidation from '../../privates/validations/animations/animationValidation';
import reporter from '../../privates/reporter';
import isAllowedComponentAPI from '../../privates/utils/componentAPISupport';
import {generateError} from '../../privates/validations/errors';
import {setAsyncFunctions} from '../../privates/utils/asyncDecorator';
import platformUtils from '../../privates/platformUtils';

const SEQUENCE = 'sequence';
const CLEAR_SEQUENCE = 'clearSequence';

//TODO: Move to some shared utils?
const capitalize = (str) => str.replace(/(^|\s)\S/g, (l) => l.toUpperCase());

//TODO: copied from Hidden Mixin, should be merged to one util function
function changeElementVisibility(RMI, compId, isHidden, cb) {
    RMI.setProps(compId, {isHidden}, cb);
}

function getWillShow(name, {opacity = 0} = {}) {
    return name === 'fade' && opacity > 0;
}

function executeApiIfSupported(comp, apiToInvoke) {
    const type = members._type.get(comp);
    const {viewerType, compType} = type;
    if (compType !== 'Gallery' || isAllowedComponentAPI(viewerType, 'animate')) {
        return apiToInvoke();
    }
    reporter.reportSdkWarning(generateError.warning_non_animatable_component({
        compNickname: comp.id
    }));
}


function buildSequenceAnimationsOptions(animations, options, id) {
    const sequenceOptions = {
        clear: false,
        data: {id},
        ...animationValidation.buildAnimationOptions(SEQUENCE, options)
    };
    const animationsOptions = animations.map(({name, ...params}) => ({
        name: capitalize(name),
        offset: 0,
        ...animationValidation.buildAnimationOptions(name, params)
    }));

    return {...sequenceOptions, animations: animationsOptions};
}


function animateSequence(animations, sequenceOptions, resolve, comp) {
    const RMI = members._RMI.get(comp);
    const compId = members._compId.get(comp);
    const {id, isHidden} = comp;

    // If not valid print validator warnings and fail silently
    const isValid = animationValidation.validateSequence(animations, sequenceOptions, id);
    if (!isValid) {
        return resolve();
    }

    // If component is hidden and animations does not change opacity, fail silently
    const willShow = animations.some(({name, ...options} = {}) => getWillShow(name, options));
    const isRepeatInfinite = sequenceOptions && sequenceOptions.repeat === -1;
    if (isHidden && !willShow) {
        return resolve();
    }

    const options = buildSequenceAnimationsOptions(animations, sequenceOptions, compId);
    const callback = isHidden && !isRepeatInfinite ? changeElementVisibility.bind(null, RMI, compId, false, resolve) : resolve;
    RMI.executeAnimation(compId, capitalize(SEQUENCE), options, callback);

    // If should change hidden property, but the sequence repeats infinitely, change visibility immediately
    if (isHidden && isRepeatInfinite) {
        changeElementVisibility(RMI, compId, false);
    }
}

// TODO: Keeping old function here for reference while developing, remove when done
// function animateSingle(name, options, RMI, compId, resolve, id, isHidden) {
//     const isValid = animationValidation.validateAnimation(name, options, id);
//     const willShow = getWillShow(name, options);
//
//     if (isValid && (!isHidden || willShow)) {
//         const animationOptions = _.assign(animationValidation.buildAnimationOptions(name, options), {clear: false});
//         const callback = isHidden ? changeElementVisibility.bind(null, RMI, compId, false, resolve) : resolve;
//         RMI.executeAnimation(compId, _.capitalize(name), animationOptions, callback);
//     } else {
//         resolve();
//     }
// }

// Hide animate behind experiments
const isAnimateExperimentOpen = () => platformUtils.isExperimentOpen('sv_corvidAnimate') ||
    platformUtils.isExperimentOpen('bv_corvidAnimate') ||
    platformUtils.isExperimentOpen('se_corvidAnimate');

class AnimatableMixin {
    animate(animationDef, animationOptions) {
        return isAnimateExperimentOpen() ? executeApiIfSupported(this,
            () => new Promise((resolve) => {
                animateSequence(animationDef, animationOptions, resolve, this);
            })
        ) : Promise.resolve();
    }

    clearAnimations() {
        return isAnimateExperimentOpen() ? executeApiIfSupported(this, () => new Promise((resolve) => {
            const RMI = members._RMI.get(this);
            const compId = members._compId.get(this);

            RMI.executeAnimation(compId, capitalize(CLEAR_SEQUENCE), {data: {id: compId}, clear: true}, resolve);
        })) : Promise.resolve();
    }
}

setAsyncFunctions(['animate', 'clearAnimations']);
export default AnimatableMixin;
